import React from 'react';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FillProfileImage from '../../Components/ImagesWithElements/FillProfileImage';
import styled from 'styled-components';
import { Button } from 'antd';
import { Input } from 'antd';
import usePortalService from '../../services/PortalService';

const { TextArea } = Input;

const Styles = styled.div`
    .progress {
    position: absolute;
    width: 100%;
    height: 6px;
    left: 0px;
    top: 0px;
    background: #2196F3
}
`

export const FillProfileEmployer3 = () => {
    const navigate = useNavigate();

    const { addDescriptionAndFilesCompany, getManagerInformation } = usePortalService();

    const [firstName, setFirstName] = useState('');

    const [description, setDescription] = useState('');

    const descriptionHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDescription(e.target.value)
    }

    useEffect(() => {
        getManagerInformation().then(result => {
            setFirstName(result.manager.firstName);
        });
    }, []);

    const handleContinue = async (e: React.FormEvent) => {
        e.preventDefault();
        const result = await addDescriptionAndFilesCompany({
            description
        });

        if (result.success) {
            navigate("/");
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <FillProfileImage firstName={firstName} />
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <p className="step">Шаг 3 из 3</p>
                        <h1 style={{ marginBottom: '32px' }}> Описание компании </h1>
                        <Form>
                            <div className="form-group">
                                <Form.Label> О компании </Form.Label>
                                <TextArea
                                    rows={20 }
                                    value={description}
                                    onChange={descriptionHandler}
                                    placeholder="Описание компании"
                                />
                            </div>
                            <br />
                            <Button type="primary" onClick={handleContinue}> Подтвердить </Button>
                            <Button type="text" onClick={() => navigate("/")}> Пропустить, заполню позже </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <Styles>
                <div className="progress"></div>
            </Styles>
        </>
    );
};